import { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { PageTrackingContext } from '../../contexts/PageTrackingContext';

const GUARD_TIMEOUT_MS = 2000;

export const PageTrackingGuard = () => {
  const location = useLocation();
  const { currentPageView } = useContext(PageTrackingContext);
  const latestPageViewIdRef = useRef(currentPageView.pageViewId);
  latestPageViewIdRef.current = currentPageView.pageViewId;

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return undefined;

    const capturedPageViewId = currentPageView.pageViewId;

    const timer = setTimeout(() => {
      if (latestPageViewIdRef.current === capturedPageViewId) {
        // eslint-disable-next-line no-console
        console.warn(
          `No PageImpression detected for route "${location.pathname}". ` +
            'Wrap your page component with <PageImpression> or withPageImpression().',
        );
      }
    }, GUARD_TIMEOUT_MS);

    return () => {
      clearTimeout(timer);
    };
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
